export const MARITAL_STATUSES = {
  single: 'single',
  divorced: 'divorced',
  married: 'married',
  separated: 'separated',
  freeUnion: 'free_union',
  widow: 'widow',
  pacs: 'pacs',
} as const

export type MaritalStatuses = ValueOf<typeof MARITAL_STATUSES>

export const MATRIMONIAL_REGIMES = {
  separationOfProperty: 'separation_of_property',
  separationWithAcquestsCompany: 'separation_with_acquests_company',
  communityOfFurnitureAndAcquests: 'community_of_furniture_and_acquests',
  reducedCommunityOfAcquests: 'reduced_community_of_acquests',
  universal: 'universal',
  legalRegimeStartDateAfter01021966: 'legal_regime_start_date_after_01_02_1966',
  legalRegimeStartDateBefore01021966:
    'legal_regime_start_date_before_01_02_1966',
  fullUniversal: 'full_universal',
  participationToAcquests: 'participation_to_acquests',
  foreign: 'foreign',
  optionalParticipationOfAcquests: 'optional_participation_of_acquests',
} as const

export type MatrimonialRegimes = ValueOf<typeof MATRIMONIAL_REGIMES>

export const MARITAL_CLAUSES = {
  none: 'none',
  clauseOfPreciput: 'clause_of_preciput',
  inegalAttribution: 'inegal_attribution',
  integralAttribution: 'integral_attribution',
  goodAquisitionOrAttributionFaculty: 'good_aquisition_or_attribution_faculty',
} as const

export type MaritalClauses = ValueOf<typeof MARITAL_CLAUSES>

export const DDV_TYPES = {
  totalityInUsufruct: 'totality_in_usufruct',
  threeFourthsUsufructAndOneFourthFullOwnership:
    'three_fourths_usufruct_and_one_fourth_full_ownership',
  availablePortionInFullOwnership: 'available_portion_in_full_ownership',
  hundredPercentInFullOwnership: 'hundred_percent_in_full_ownership',
}

export type DdvTypes = ValueOf<typeof DDV_TYPES>

export const DISMEMBERMENT_OPTIONS = {
  fullOwnership: 'full_ownership',
  bareOwnership: 'bare_ownership',
  usufruct: 'usufruct',
} as const

export const FULL_OWNERSHIP_BENEFICIARY_CLAUSES = [
  'designated',
  'surviving_spouse_or_designated',
]
